/** Une seule reprise automatique par URL et par version, sans toucher au journal hors ligne. */
export function reprendreApresModuleAbsent(): boolean {
  if (!navigator.onLine) return false
  const cle = `ridomio-reprise-module:${location.pathname}:${import.meta.url}`
  if (sessionStorage.getItem(cle) === 'tentee') return false
  sessionStorage.setItem(cle, 'tentee')
  const cible = new URL(location.href)
  cible.searchParams.set('version', Date.now().toString())
  location.replace(cible.toString())
  return true
}

export function brancherRenouvellement(): void {
  window.addEventListener('vite:preloadError', (evenement) => {
    if (reprendreApresModuleAbsent()) evenement.preventDefault()
  })
}
